import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbilityServiceSignal } from '@casl/angular';
import { PureAbility } from '@casl/ability';
import { CustomerService } from 'api';
import { NameCasePipe, NullFormatterPipe, PhonePipe } from 'common';
import {
  BehaviorSubject,
  catchError,
  filter,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { ButtonComponent } from 'ui-elements/button';

@Component({
  selector: 'ss-stx-shared-customer-primary-contact',
  templateUrl: './customer-primary-contact.component.html',
  styleUrls: ['./customer-primary-contact.component.scss'],
  imports: [
    CommonModule,
    ButtonComponent,
    PhonePipe,
    NameCasePipe,
    NullFormatterPipe,
    RouterModule,
  ],
})
export class CustomerPrimaryContactComponent {
  private ability =
    inject<AbilityServiceSignal<PureAbility>>(AbilityServiceSignal);
  private customerService = inject(CustomerService);

  _customerNumber = new BehaviorSubject<number | undefined>(undefined);
  @Input() set customerNumber(customerNumber: number | undefined) {
    this._customerNumber.next(customerNumber);
  }
  @Input() isCompany?: boolean;
  @Input() isReseller?: boolean;
  @Input() showEditPrimaryInfoButton?: boolean;
  @Output() edit = new EventEmitter();
  get customerNumber(): number | undefined {
    return this._customerNumber.getValue();
  }
  primaryContactError$ = new BehaviorSubject<Error | undefined>(undefined);
  public primaryContact$? = this._customerNumber.pipe(
    filter((customer) => !!customer),
    switchMap((customer) =>
      this.customerService.getPrimaryAdditionalContact(customer!)
    ),
    tap((_) => {
      this.primaryContactError$.next(undefined);
    }),
    catchError((error) => {
      this.primaryContactError$.next(error);
      return throwError(() => error);
    })
  );

  can(action: string, subject: string): boolean {
    return this.ability.can(action, subject);
  }

  //#region Public methods
  editPrimaryContact() {
    this.edit.emit();
  }
  //#endregion
}
